module.exports = "/images/zw.svg?0cd028a07913e52d3faf1598e37a6357";